import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '919059333987';
  const message = 'Hi, I would like to know more about studying abroad.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group flex items-center"
      aria-label="Chat with us on WhatsApp"
    >
      {/* Label slides out on hover */}
      <span className="mr-3 max-w-0 overflow-hidden group-hover:max-w-[220px] transition-all duration-500 ease-out">
        <span className="block bg-navy-900 text-white text-sm font-semibold px-4 py-2.5 rounded-full whitespace-nowrap shadow-lift">
          Chat with us
        </span>
      </span>

      <span className="relative">
        <span className="absolute inset-0 rounded-full bg-emerald-500 animate-pulse-ring"></span>
        <span className="relative flex w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white items-center justify-center shadow-lift transition-all duration-300 group-hover:scale-105">
          <MessageCircle className="w-7 h-7" strokeWidth={2.25} />
        </span>
      </span>
    </a>
  );
};

export default WhatsAppButton;
